import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Skeleton from "../skelton";

const FeatureGrid = ({ gridActress, gridActor, gridMovie, gridEvent }) => {
  const [actress, setActress] = useState(gridActress || {});
  const [actor, setActor] = useState(gridActor || {});
  const [event, setEvent] = useState(gridEvent || {});
  const [movie, setMovie] = useState(gridMovie || {});

  const [loading, setLoading] = useState(false);
  const [hydrating,setHydrating] = useState(true)
  const [error, setError] = useState(null);

  const isFirstLoad = useRef(true);


  
    

  useEffect(() => {

    
    
    if (
      Object.keys(actress).length > 0 &&
      Object.keys(actor).length > 0 &&
      Object.keys(event).length > 0  &&
      Object.keys(movie).length > 0 &&
      isFirstLoad.current
    ) {
      isFirstLoad.current = false;
      return;
    }

    setLoading(true);

    const fetchData = async () => {
      try {
        const urls = [
          "https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=1&start=0&limit=1",
          "https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=2&start=0&limit=1",
          "https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=10&start=0&limit=1",
          "https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=8&start=0&limit=1",
        ];

        const responses = await Promise.all(urls.map((url) => fetch(url)));

        const data = await Promise.all(
          responses.map((res) => {
            if (!res.ok) throw new Error("API failed");
            return res.json();
          })
        );

        setActress(data[0]?.photosHomeByType?.[0] || {});
        setActor(data[1]?.photosHomeByType?.[0] || {});
        setEvent(data[2]?.photosHomeByType?.[0] || {});
        setMovie(data[3]?.photosHomeByType?.[0] || {});
      } catch (e) {
        console.error("Fetch error:", e);
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [gridActress, gridActor, gridMovie, gridEvent]);


  useEffect(()  =>   {
 
     
    const hydrationTimer = setTimeout(() => {
          
             setHydrating(false)

       },500);


       return () => clearTimeout(hydrationTimer);

   },[])


  
  if (error)  {
        
        return  <div className="featured-grid">
         {[0, 0, 0, 0].map((item, index) =>  <Link
      key={index}
      to=""
      className={`feature-card`}
    >
      <Skeleton type="feature-grid-img" />

    </Link> )}
    </div>
     
  } 

  return (
    <div className="featured-grid">

   
         {(loading || hydrating) && [0, 0, 0, 0].map((item, index) =>  <Link
      key={index}
      to=""
      className={`feature-card`}
    >
      <Skeleton type="feature-grid-img" />
     
    </Link> )}
    



            {!loading && [actress, actor, event, movie].map((item, index) => {
          if ( Object.keys(item).length <= 0) {
          return (
            <Link to="" key={index} className={`feature-card tall ${hydrating ? 'd-none' : ''}`}>
            <Skeleton type="feature-grid-img" />
            </Link>
          );
        }

        return (
          <Link
            key={index}
            to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )}
            className={`feature-card tall ${hydrating ? 'd-none' : ''}`}
          >
            <img
              src={item.stimg ? item.stimg : ''}
              alt={item.title ? item.title : ''}
              loading={index === 0 ? "eager" : "lazy"}
            />
            <div className="feature-overlay">
              <span>{item.title ? item.title : ''}</span>
            </div>
          </Link>
        );
                })}


    </div>
  );
};

export default FeatureGrid;